import { useState } from 'react';

// antd's Modal mounts its children on first open, so a Form inside it is unmounted until then and
// calling its form instance warns "Instance created by `useForm` is not connected to any Form element".
export function useHasModalOpened(open: boolean): boolean {
  const [hasOpened, setHasOpened] = useState(open);

  if (open && !hasOpened) {
    setHasOpened(true);
  }

  return hasOpened;
}
